import Vue from "vue";
import Router from "./router";
import "./styles/global.css";
import "animate.css/animate.min.css";

Vue.config.productionTip = false;

if ("scrollRestoration" in window.history) {
  window.history.scrollRestoration = "manual";
}

new Vue({
  router: Router,
  render: (h) => h({ render: (h) => h("router-view") }),
}).$mount("#app");
